import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../services';

/**
 * Generated class for the ProductCreateObservationsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-create-observations',
    templateUrl: 'product-create-observations.html',
})
export class ProductCreateObservationsPage {

    update_state: boolean = false;
    product_uid: string;
    product_name: string;
    product: any;
    observations: string = '';

    _observations: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public productsServices: ProductsServices) {

        this.update_state = this.navParams.get('update');
        this.product_uid = this.navParams.get('product_uid');
        this.product_name = this.navParams.get('product_name');
        this._observations = this.navParams.get('observations');
        this.product = this.navParams.get('product');
    }

    public getInitObservations(editor: any) {
        if (editor.html) {
            this.observations = editor.html;
        }
    }

    update() {
        this.productsServices.afs.collection('products').doc(this.product_uid).update({
            'observations': this.observations,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            if (this.update_state) {
                this.globals.GAtrackView('Products', 'Products - Observaciones - Update', this.globals.restaurant.email, 'Create/Update', 'Update observaciones', 'Products', this.product_name);
            } else {
                this.globals.GAtrackView('Products', 'Products - Observaciones - Create', this.globals.restaurant.email, 'Create/Update', 'Create observaciones', 'Products', this.product_name);
            }
            this.navCtrl.pop();
        });
    }



}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-observations/product-create-observations.ts